import { Directive } from '@angular/core';
import { CheckboxComponent } from '@thiememeulenhoff/albert';
import { BaseValueAccessorDirective, valueAccessorProvider } from './base';

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    'a-checkbox[ngModel],a-checkbox[formControl],a-checkbox[formControlName]',
  providers: [valueAccessorProvider(CheckboxValueAccessorDirective)],
})
export class CheckboxValueAccessorDirective extends BaseValueAccessorDirective<
  CheckboxComponent,
  boolean
> {
  override onInput = () => {
    this.onChangeFn?.(this.elementRef.nativeElement.checked);
  };

  override onChange = () => {
    this.onChangeFn?.(this.elementRef.nativeElement.checked);
  };

  override writeValue(obj: boolean): void {
    super.writeValue(obj);
    this.elementRef.nativeElement.checked = obj;
  }
}
